export enum SvcNowFuncTab {
    Register = 'Register',
    RoomMapping = 'RoomMapping',
    DeskOfficeConfig = 'DeskOfficeConfig',
    CalendarConfig = 'CalendarConfig'
}

export enum PairingContentAssignMode {
    Policy = 'Policy',
    Manual = 'Manual'
}